import { IModelDesignData } from '../../babylonjs/type/designType'
import { IProduct } from '../type/productType'
import { get, set } from 'local-storage'
import { ICart } from '../type/cartType'
import { ICompletedContextState, IModel } from '../../babylonjs/type/modelType'
import { v4 as uuidv4 } from 'uuid'
import { client } from '../../graphql/client'
import { GET_PRODUCT_WITH_VARIANTS } from '../../graphql/query'
import { OrderType, Product } from '../../babylonjs/type/backendType'
import {
  CREATE_CART_ITEMS_MUTATION,
  EMPTY_CART_MUTATION,
} from '../../graphql/mutation'

const storageKey = 'cart'

type ICartItemInfo = {
  productId: string
  productOptionValueId: string
}
type ICartItem = {
  id: string
  shopId: string
  salesChannelId: string
  ownedByOrganisationId: string
  cartId: string
  productId: string
  productPackageId: string
} & ICartItemInfo

export const addToCart = async (
  model: IModel,
  design: IModelDesignData,
  context: ICompletedContextState
): Promise<boolean> => {
  // products loop
  const cartId = process.env.REACT_APP_CART_ID ?? ''
  const ownedByOrganisationId = process.env.REACT_APP_ORGANISATION_ID ?? ''
  const salesChannelId = process.env.REACT_APP_SALESCHANNEL_ID ?? ''
  const shopId = context.shop.id
  const productPackageId = model.productPackageId

  if (productPackageId) {
    const cartItemInfos: (ICartItemInfo[] | null)[] = await Promise.all(
      design.modelConfig.meshes.map(async mesh => {
        const meshGroup = model.meshes.find(m => mesh.id === m.id)
        const productId = meshGroup?.productId
        if (meshGroup && productId) {
          // const variantIds = mesh.variants.map(variant => variant.id)
          const color = mesh.colors?.[0]?.id
          const material = mesh.textures?.[0]?.id

          const materialId = color || material

          if (materialId) {
            const result = await client.query<{ product: Product }>({
              query: GET_PRODUCT_WITH_VARIANTS,
              variables: {
                id: productId,
              },
            })

            if (result.data?.product) {
              const product = result.data.product
              const productOptionValueIds = mesh.variants.map(variant => {
                const optionValue = product.optionValues?.find(ov => {
                  let variants = ov.optionValueIds as string[]
                  return (
                    variants.filter(
                      id => ![variant.id, materialId].includes(id)
                    ).length === 0
                  )
                })

                return optionValue?.id ?? ''
              })

              return productOptionValueIds.map(productOptionValueId => ({
                productId,
                productOptionValueId,
              }))
            }
          }

          // add to cart api
        }

        return null
      })
    )

    const cartItems: ICartItem[] = []

    ;(cartItemInfos.filter(item => item) as ICartItemInfo[][]).forEach(
      cartItemInfo => [
        cartItems.push(
          ...cartItemInfo.map(info => ({
            ...info,
            cartId,
            shopId,
            ownedByOrganisationId,
            salesChannelId,
            productPackageId,
            id: uuidv4(),
            orderType: OrderType.STOCK,
          }))
        ),
      ]
    )

    await emptyCart(cartId)

    const result = await client.mutate({
      mutation: CREATE_CART_ITEMS_MUTATION,
      variables: {
        input: cartItems,
      },
    })

    return !!result.data
  }

  return false
}

export const emptyCart = async (cartId: string) => {
  await client.mutate({
    mutation: EMPTY_CART_MUTATION,
    variables: {
      cartId,
    },
  })
}

// export const getCart = (): ICart => {
//   const cart = get<ICart>(storageKey) ?? createCart()

//   return cart
// }

// const createCart = () => {
//   const newCart = {
//     id: uuidv4(),
//     cartItems: [],
//     total: 0,
//   }
//   set<ICart>(storageKey, newCart)

//   return newCart
// }

// export const getCartItems = (): ICartItem[] => {
//   const cart = getCart()
//   return cart.cartItems
// }

// export const updateCartItem = (item: ICartItem): ICartItem | null => {
//   const cart = getCart()

//   if (item.cartId === cart.id) {
//     set<ICart>(storageKey, {
//       ...cart,
//       cartItems: [...cart.cartItems.filter(i => i.id !== item.id), item],
//     })
//   }

//   return getCart().cartItems.find(i => i.id === item.id) ?? null
// }

// export const deleteCartItem = (item: ICartItem): boolean => {
//   const cart = getCart()

//   set<ICart>(storageKey, {
//     ...cart,
//     cartItems: [...cart.cartItems.filter(i => i.id !== item.id)],
//   })

//   return getCart().cartItems.some(i => i.id === item.id)
// }
